import { defineMessages } from "react-intl";

export const scope = "cb.containers.VerifyEmail";

export default defineMessages({
    verifyingEmailTitle: {
        id: `${scope}.verifyingEmailTitle`,
        defaultMessage: "Verifying your email",
    },
    verifyingEmailMessage: {
        id: `${scope}.verifyingEmailMessage`,
        defaultMessage:
            "Please wait while we verify your email address.",
    },
    emailVerifiedTitle: {
        id: `${scope}.emailVerifiedTitle`,
        defaultMessage: "Email Verified!",
    },
    emailVerifiedMessage: {
        id: `${scope}.emailVerifiedMessage`,
        defaultMessage:
            "Your email has been successfully verified.",
    },
    redirectMessage: {
        id: `${scope}.redirectMessage`,
        defaultMessage:
            "Redirecting you to the home page in <red>{countdown}</red> seconds...",
    },
    verificationFailedTitle: {
        id: `${scope}.verificationFailedTitle`,
        defaultMessage: "Verification Failed",
    },
    invalidVerificationLink: {
        id: `${scope}.invalidVerificationLink`,
        defaultMessage: "Invalid verification link.",
    },
    unableToVerifyEmail: {
        id: `${scope}.unableToVerifyEmail`,
        defaultMessage: "Unable to verify your email. Please try again.",
    },
    goToHome: {
        id: `${scope}.goToHome`,
        defaultMessage: "Go to Home",
    },
});